module.exports = __webpack_public_path__ + "static/flags/ZA-2651700e9e4b9c23f0b4022b64d86586.gif";